import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import CapabilityForm from './CapabilityForm';
import { Icon } from 'js/components';
import Checkbox from 'js/components/Forms/Checkbox';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import { positionAfter } from './ordering';
import styles from './CapabilitySet.module.scss';

function NewCapabilityModal({
  context,
  onSubmit = () => {},
  onSubmitAnother = () => {},
  onCancel = () => {},
  isOpen = false,
  keepAdding = false,
  onKeepAddingChange = () => {},
}) {
  const { path = [], capabilitySet = null } = context ?? {};
  const parent = path.length > 0 ? path[path.length - 1] : null;

  // The siblings in `context` are a snapshot from when the modal opened, so
  // remember what this modal has added to keep each new capability last
  const [addedPositions, setAddedPositions] = useState([]);

  const withPlacement = (values) => ({
    ...values,
    parent_id: parent?.id,
    position: positionAfter([
      ...((parent ? parent.children : capabilitySet?.capabilities) ?? []),
      ...addedPositions.map((position) => ({ position })),
    ]),
  });

  const handleSubmit = async (values) => {
    const capability = withPlacement(values);

    if (!keepAdding) {
      return onSubmit(capability);
    }

    await onSubmitAnother(capability);
    setAddedPositions((positions) => [...positions, capability.position]);
    return { resetForm: true };
  };

  return (
    // The form focuses the name field itself; the modal's own autofocus would
    // move focus to the dialog once it finishes opening
    <Modal isOpen={isOpen} className={styles.modal} autoFocus={false}>
      <ModalHeader>
        <div className={styles['modal-path-list']}>
          {[...path].reverse().map((p) => (
            <div className={styles['modal-path-list-item']} key={p.name}>
              <div className={styles['modal-path-list-item-name']}>
                {p.name}
              </div>
              <div className={styles['modal-path-list-item-chevron']}>&gt;</div>
            </div>
          ))}
          <div className={styles['modal-path-list-item']}>
            <div className={styles['modal-path-list-item-name']}>
              {capabilitySet?.name}
            </div>
            <div className={styles['modal-path-list-item-chevron']}>&gt;</div>
          </div>
        </div>
        <div className="primary">Add a capability</div>
      </ModalHeader>
      <ModalBody>
        <div className={styles['capability-form']}>
          <CapabilityForm
            autoFocusName
            onSubmit={handleSubmit}
            onCancel={onCancel}
            submitText={
              <>
                <Icon icon={faPlus} className="icon-left" />
                Add
              </>
            }
            extraActions={
              <Checkbox
                labelClass="mb-0 ml-2"
                checked={keepAdding}
                onChange={(event) => onKeepAddingChange(event.target.checked)}
              >
                Add another
              </Checkbox>
            }
          />
        </div>
      </ModalBody>
    </Modal>
  );
}

export default NewCapabilityModal;
